<h2 mat-dialog-title>Vincular nova organização</h2>
<mat-dialog-content class="mat-typography">
    <p>Veja abaixo as organizações disponíveis, se preferir, realize sua busca no campo abaixo:</p>
    <div class="row">
        <div class="col-xs-12">
            <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>Faça sua busca pela instituição ou cidade</mat-label>
                <input type="text" matInput  [(ngModel)]="search"  [ngModelOptions]="{standalone: true}"
                placeholder="Digite aqui sua busca pela instituição ou cidade">          
            </mat-form-field>
        </div>           
    </div>          
    <div class="row">
        <div class="col-xs-12 col-lg-6 "  *ngFor="let organization of organizationsFilter">
            <mat-card  >               
                <div class="col-xs-12">
                    <div class="col-xs-12">
                        <div class="desc">{{organization?.alias }}</div>
                        <div class="desc">{{ getCity(organization.organization_id) ?? 'Sem localização' }}</div>                     
                    </div>
                    <div class="col-xs-12 actions">
                        <div class="col-xs-12 col-md-6 bt">
                            <button mat-stroked-button [disabled]="organization.isHidden"  color="primary" (click)="linkOrganization(organization)">Vincular</button>
                        </div>
                        <div class="col-xs-12 col-md-6 bt">
                            <button mat-stroked-button  color="primary" (click)="openOrganizationDetailForm(organization)">Detalhes</button>
                        </div> 
                    </div>                    
                </div>      
            </mat-card>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button  color="primary"  [mat-dialog-close]="refreshMainComponent">Fechar</button>  
</mat-dialog-actions>
